<template>
  <div>
    <p class="lead">Allow KoalaBoss to access a site protected by HTTP authentication.</p>
    <c-row class="mb-2">
      <c-col cols="10" sm="1">
        Enabled
      </c-col>
      <c-col cols="2" sm="11">
        <c-switch
          class="mx-1"
          color="primary"
          name="switch1"
          variant="3d"
          :checked.sync="applyAuth"
          @update:checked="toggleEnabled"
        />
      </c-col>
    </c-row>
    <c-input
      v-model="data.username"
      label="Username"
      class="input"
      type="text"
      placeholder="Enter username"
      @keydown="allowSave"
    />
    <c-input
      v-model="data.password"
      label="Password"
      class="input"
      type="password"
      placeholder="Enter password"
      @keydown="allowSave"
    />

    <c-button-group>
      <c-button color="primary" :disabled="saving" @click="save">Save</c-button>
      <c-button v-if="showCancelButton" color="secondary" @click="cancelEdit">Reset</c-button>
    </c-button-group>
  </div>
</template>

<script>
import _ from 'lodash';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'EditAuthentication',
  props: {
    site: Object,
  },
  data() {
    return {
      error: null,
      enabled: null,
      saving: false,
      showCancelButton: false,
      authType: 'http-auth',
      isSaving: false,
      applyAuth: false,
      data: {
        username: null,
        password: null,
      },
    };
  },

  mounted() {
    this.siteId = this.$route.params.siteId;
    this.setDefaults();
  },

  methods: {
    setDefaults() {
      this.applyAuth = _.get(this.site, 'authenticationOpts.httpAuth.applyAuth', false);
      this.data = {
        name: this.site.name,
        siteAddress: this.site.siteAddress,
      };
    },
    cancelEdit() {
      this.setDefaults();
      this.showCancelButton = false;
    },
    allowSave() {
      this.showCancelButton = true;
      // this.enableSave = true
    },

    toggleEnabled() {
      const data = {
        siteId: this.site._id,
        applyAuth: this.applyAuth,
        authType: this.authType,
      };
      this.$http
        .post(buildEndpoint('site/authentication/toggle-apply-auth'), data)
        .then((response) => {
          this.isSaving = false;
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: `HTTP Authentication ${this.applyAuth ? 'enabled' : 'disabled'}`,
            });
            // if (!this.site.authenticationOpts.httpAuth) {
            //   this.site.authenticationOpts.httpAuth = {}
            // }
            // this.site.authenticationOpts.httpAuth.applyAuth = this.applyAuth
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error saving HTTP Authentication settings',
            });
          }
        })
        .catch((error) => {
          // this.isSaving = false
          // this.error = error
          this.$store.commit('addErrorMessage', {
            header: 'Error saving HTTP Authentication settings',
          });
        });
    },

    save() {
      // if (!this.data.username || !this.data.password) {
      //   return;
      // }

      this.saving = true;
      this.error = null;

      const data = {
        siteId: this.site._id,
        username: this.data.username,
        password: this.data.password,
        authType: this.authType,
      };

      this.$http
        .post(buildEndpoint('site/authentication/update'), data)
        .then((response) => {
          this.saving = false;
          if (response.data.success) {
            this.showCancelButton = false;
            this.data = {
              name: this.data.name,
              siteAddress: this.data.siteAddress,
            };
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'HTTP Authentication settings updated',
            });
            // this.$router.push({name: 'detailsSite', params: {siteId: this.siteId}})
            // all good
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error saving HTTP Authentication settings',
            });
          }
        })
        .catch((error) => {
          this.saving = false;
          this.error = error;
        });
    },
  },
};
</script>
